import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Fade } from "react-awesome-reveal";
import toast from "react-hot-toast";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import UserIcon from "../../assets/icons/profile.svg";
import LockIcon from "../../assets/icons/lock.svg";
import Input from "../../components/form/input";
import LoadingButton from "../../components/common/loadingButton";
import apiClient from "../../services/apiClient";
import useStore from "../../features/store";

const UpdateProfile = () => {
  //@ts-ignore
  const { profile, fetchProfile } = useStore();
  const navigate = useNavigate();

  // Yup validation schema
  const schema = yup.object().shape({
    first_name: !profile?.user?.first_name
      ? yup.string().required("نام الزامی است")
      : yup.string().notRequired(),
    last_name: !profile?.user?.last_name
      ? yup.string().required("نام خانوادگی الزامی است")
      : yup.string().notRequired(),
  });

  const [loading, setLoading] = useState(false);

  const {
    handleSubmit,
    formState: { errors, isValid, isDirty },
    control,
    reset,
    ...form
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  async function updateUserProfile(profileData: any) {
    setLoading(true);

    try {
      const data = {
        first_name: profileData.first_name,
        last_name: profileData.last_name,
      };
      //@ts-ignore
      const response = await apiClient.patch("/profile", data);

      if (response.status === 200) {
        fetchProfile();
        setLoading(false);
        navigate("/");
        reset();
      }
    } catch (error) {
      setLoading(false);
      toast.error("مشکلی در ثبت اطلاعات پیش آمد");
      reset();
    }
  }

  const onSubmit = (data: any) => {
    updateUserProfile(data);
  };

  return (
    <div className="flex-1">
      <h2 className="mt-5 mb-6 text-center text-xl font-bold">
        تکمیل پروفایل کاربری
      </h2>
      <Fade triggerOnce>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex-1 w-full max-w-lg mx-auto mt-0 flex flex-col justify-between mb-10"
        >
          <div className="flex-1 mb-10">
            {!profile?.user?.first_name && (
              <Input
                form={form}
                errors={errors}
                title="* نام:"
                icon={<img src={UserIcon} alt="نام" />}
                id="first_name"
              />
            )}

            {!profile?.user?.last_name && (
              <Input
                form={form}
                errors={errors}
                title="* نام‌خانوادگی:"
                icon={<img src={UserIcon} alt="نام‌خانوادگی" />}
                id="last_name"
              />
            )}
          </div>

          <div className="flex items-center justify-between">
            <LoadingButton
              title="ثبت"
              type="submit"
              disabled={!isValid || !isDirty || loading}
              loading={loading}
              width={profile?.user.first_name ? `w-[63%]` : "w-full"}
            />
          </div>
        </form>
      </Fade>
    </div>
  );
};

export default UpdateProfile;
